/**
 * Audit logs page (placeholder until the audit log viewer is implemented)
 */
export function Audit() {
  return (
    <div className="page">
      <h1>Audit Logs</h1>
      <p>View system activity and audit trail.</p>
      <p className="page-hint">Audit log viewer will be implemented in a future subtask</p>
    </div>
  );
}
